export enum ETransactionStatus {
    PENDING = 1,
    CANCELLED = 2,
    PAID = 3,
    REFUSED = 4,
    REFUNDED = 5,
    DISPUTE = 6,
    CHARGED_BACK = 7,
    WAITING = 8
}

export enum EAnticipationStatus {
    READY = 0,
    REQUESTED = 1,
    APPROVED = 2,
    SUCCEEDED = 3,
    CANCELLED = 4,
    SIMULATED = 5,
    REJECTED = 6,
    INVALID = 7,
    EXPIRED = 8
}

export enum ETransactionGetPublicTokenStatus {
    PENDING = 1,
    EXPIRED = 2,
    PAID = 3,
}
